/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useMemo, useState } from "react";
import { RichTextComponent } from "cms/components/rich-text/rich-text";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { ButtonCtaItem } from "./button-cta-item";

const ButtonCtaComponent = (props) => {
    const component = props?.component;
    const title = component.title;
    const subtitle = component.subtitle;
    const description = component.description;
    const linkProperties = component?.linkProperties ?? {};
    console.log("linkProperties::", linkProperties);

    const [links, setLinks] = useState([]);
    const [loadingLinks, setLoadingLinks] = useState(false);

    const { token } = useAuth();

    const link_guids = useMemo(() => {
        return component.links || [];
    }, [component.links]);

    // const onClickLink = (link) => {
    //     window.open(link?.url, "_blank");
    // };

    useEffect(() => {
        const getLinks = async () => {
            if (link_guids.length === 0) {
                return;
            }

            try {
                setLoadingLinks(true);
                const loadedLinks = await Promise.all(
                    link_guids.map((linkGuid) =>
                        SimpliCityAdminSDK.link.findOne(token, linkGuid)
                    )
                );
                setLinks(loadedLinks);
            } catch (error) {
                console.error("Error loading links:", error);
            } finally {
                setLoadingLinks(false);
            }
        };
        getLinks();
    }, [link_guids, token]);

    return (
        <div className="button-cta-container">
            <div className="button-cta-content">
                <div className="button-cta-title">
                    <h2 className="button-cta-title-main">{title}</h2>
                    <h2 className="button-cta-title-subtitle">{subtitle}</h2>
                </div>
                <div className="button-cta-description">
                    <RichTextComponent component={{ richtext: description }} />
                </div>
                <div className="button-cta-links">
                    {loadingLinks ? (
                        <div className="button-cta-loading">Loading...</div>
                    ) : (
                        links.map((link, index) => {
                            const linkGuid = link?.guid;
                            const specificLinkProperties = linkProperties[linkGuid] || {};

                            return (
                                <ButtonCtaItem
                                    key={index}
                                    link={link}
                                    linkProperties={specificLinkProperties}
                                />
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

ButtonCtaComponent.displayName = "ButtonCtaComponent";
export { ButtonCtaComponent };

